import moment from 'moment'
import colors from 'theme/colors'
import strings from 'strings'

const t = strings.TABLE_DEFAULTS

const getInvitedCarrierData = (data: any) => {
  const codeTypes = ['TCID', 'DOT', 'MC', 'SCAC', 'UUID']
  const tableData = data?.map((item: any) => {
    const getUuid = () => {
      const val = item?.carrierInfo?.carrierCodes.filter(
        (item: any) => item.codeType === 'UUID'
      )[0]?.codeValue
      return !val ? t.DASH_VALUE : val
    }
    const getScac = () => {
      const val = item?.carrierInfo?.carrierCodes.filter(
        (item: any) => item.codeType === 'SCAC'
      )[0]?.codeValue
      return !val ? t.DASH_VALUE : val
    }
    const getCuid = () => {
      const val = item?.carrierInfo?.carrierCodes.filter((item: any) => {
        return !codeTypes.includes(item.codeType)
      })[0]?.codeValue
      return !val ? t.DASH_VALUE : val
    }
    return {
      carrierId: item?.carrierInfo?.carrierId,
      carrierName: item?.carrierInfo?.carrierName,
      firstName: item?.contactInfo?.firstName,
      lastName: item?.contactInfo?.lastName,
      email: item?.contactInfo?.email,
      dot:
        item?.carrierInfo?.carrierCodes.filter(
          (item: any) => item.codeType === 'DOT'
        )[0]?.codeValue || t.DASH_VALUE,
      mc:
        item?.carrierInfo?.carrierCodes.filter(
          (item: any) => item.codeType === 'MC'
        )[0]?.codeValue || t.DASH_VALUE,
      scac: getScac(),
      uuid: getUuid(),
      cuid: getCuid(),
      eldVendorDisplayName: item?.lastCheckedEld
        ? item.lastCheckedEld
        : item?.eldInfo[0]?.eldVendorDisplayName || 'Unknown',
      invitedDate:
        moment(item.statusInfo?.invited).format('MM/DD/YYYY') || t.DASH_VALUE,
      status: item?.statusInfo?.status,
    }
  })
  return tableData
}

const getCarrierTableData = (data: any) => {
  const codeTypes = ['TCID', 'DOT', 'MC', 'SCAC', 'UUID', 'POLICY_ID']
  let index = 0;
  const tableData = data?.map((item: any) => {
    const getScac = () => {
      const val = item?.carrierInfo?.carrierCodes.filter(
        (item: any) => item.codeType === 'SCAC'
      )[0]?.codeValue
      return !val ? t.DASH_VALUE : val
    }
    const getCuid = () => {
      const val = item?.carrierInfo?.carrierCodes.filter((item: any) => {
        return !codeTypes.includes(item.codeType)
      })[0]?.codeValue
      return !val ? t.DASH_VALUE : val
    }
    const getCuidName = () => {
      const val = item?.carrierInfo?.carrierCodes.filter((item: any) => {
        return !codeTypes.includes(item.codeType)
      })[0]?.codeType
      return !val ? t.DASH_VALUE : val
    }
    const getPolicyId = () => {
      const val = item?.carrierInfo?.carrierCodes.filter(
        (item: any) => item.codeType === 'POLICY_ID'
      )[0]?.codeValue
      return !val ? t.DASH_VALUE : val
    }
    const tableDataWithEld = item?.eldInfo?.map((eldItem: any) => ({
      index: index++,
      carrierId: item?.carrierInfo?.carrierId,
      carrierName: item?.carrierInfo?.carrierName,
      firstName: item?.contactInfo?.firstName,
      lastName: item?.contactInfo?.lastName,
      email: item?.contactInfo?.email,
      safetyContactEmail: item?.contactInfo?.safetyContactEmail,
      dot:
        item?.carrierInfo?.carrierCodes.filter(
          (codeItem: any) => codeItem.codeType === 'DOT'
        )[0]?.codeValue || t.DASH_VALUE,
      mc:
        item?.carrierInfo?.carrierCodes.filter(
          (codeItem: any) => codeItem.codeType === 'MC'
        )[0]?.codeValue || t.DASH_VALUE,
      scac: getScac(),
      cuid: getCuid(),
      cuidName: getCuidName(),
      policyId: getPolicyId(),
      credentialStatus: eldItem?.credentialStatus,
      eldVendor: eldItem?.eldVendor,
      eldVendorDisplayName: eldItem?.eldVendorDisplayName,
      confidentialEvents: eldItem?.confidentialEvents,
      numberOfTrucks: eldItem?.numberOfTrucks || t.DASH_VALUE,
      numberOfDrivers: eldItem?.numberOfDrivers || t.DASH_VALUE,
      statusInfo:
        (item?.statusInfo?.onboarded !== null &&
        item?.statusInfo?.onboarded !== undefined)
          ? moment(item?.statusInfo?.onboarded).format('MM/DD/YYYY')
          : t.DASH_VALUE,
      driverDataEnabled: eldItem?.eldDataSharing?.driverDataEnabled,
      hoursOfServiceDataEnabled: eldItem?.eldDataSharing?.hoursOfServiceDataEnabled,
      engineDataEnabled: eldItem?.eldDataSharing?.engineDataEnabled,
      letterOfAuthorizationUrl: eldItem?.letterOfAuthorizationUrl,
      eldLetterOfAuthorizationUrl: eldItem?.eldLetterOfAuthorizationUrl || '',
      onboardedDate: item?.statusInfo?.onboarded,
    }));
    return tableDataWithEld;
  })
  return tableData?.flat();
}

const getSecondaryCarrierTableData = (data: any, codeTypes: any) => {
  let index = 0
  const getCuid = () => {
    const val = data?.masterCarrier?.carrierInfo.carrierCodes.find(
      (codeItem: any) => !codeTypes.includes(codeItem.codeType)
    )
    return !val ? t.DASH_VALUE : val.codeValue
  }
  const getPrimaryCode = () => {
    for (const codeType of codeTypes) {
      const val = data?.masterCarrier?.carrierInfo.carrierCodes.find(
        (codeItem: any) => codeItem.codeType === codeType
      )
      if (val) {
        return val.codeValue
      }
    }
    return t.DASH_VALUE
  }
  const getPrimaryCodeType = () => {
    for (const codeType of codeTypes) {
      const val = data?.masterCarrier?.carrierInfo.carrierCodes.find(
        (codeItem: any) => codeItem.codeType === codeType
      )
      if (val) {
        return val.codeType.toLowerCase()
      }
    }
    return 'dot'
  }

  const tableData = data?.myAccounts?.map((item: any) => {
    const tableDataWithEld = item?.eldInfo?.map((eldItem: any) => ({
      index: index++,
      carrierId: item?.carrierInfo?.carrierId,
      carrierName: item?.carrierInfo?.carrierName,
      firstName: item?.contactInfo?.firstName,
      lastName: item?.contactInfo?.lastName,
      email: item?.contactInfo?.email,
      [getPrimaryCodeType()]: getPrimaryCode(), // Set codetype and codevalue of master carrier
      cuid: getCuid(),
      eldVendorDisplayName: eldItem?.eldVendorDisplayName,
      eldVendor: eldItem?.eldVendor,
      onboardDate:
        item?.statusInfo?.onboarded !== null &&
        item?.statusInfo?.onboarded !== undefined
          ? moment(item?.statusInfo?.onboarded).format('MMM DD, YYYY')
          : t.DASH_VALUE,
      letterOfAuthorizationUrl: eldItem?.letterOfAuthorizationUrl,
      status: item?.statusInfo?.status,
      activeVehicles: eldItem?.numberOfTrucks || t.DASH_VALUE,
    }))
    return tableDataWithEld
  })
  return tableData?.flat()
}

const getMasterCarrierData = (responseData: any, codeTypes: any) => {
  return {
    carrierName: responseData?.masterCarrier?.carrierInfo?.carrierName || t.DASH_VALUE,
    contactName: responseData?.masterCarrier?.contactInfo
      ? `${responseData.masterCarrier.contactInfo.firstName} ${responseData.masterCarrier.contactInfo.lastName}`
      : t.DASH_VALUE,
    contactEmail: responseData?.masterCarrier?.contactInfo?.email || t.DASH_VALUE,
    primaryCode:
      responseData?.masterCarrier?.carrierInfo?.carrierCodes.filter(
        (item: any) => codeTypes.includes(item.codeType)
      )[0]?.codeValue || t.DASH_VALUE,
    primaryCodeType:
      responseData?.masterCarrier?.carrierInfo?.carrierCodes.filter(
        (item: any) => codeTypes.includes(item.codeType)
      )[0]?.codeType || 'DOT',
    cuid:
      responseData?.masterCarrier?.carrierInfo?.carrierCodes.filter(
        (item: any) => {
          return !codeTypes.includes(item.codeType)
        }
      )[0]?.codeValue || t.DASH_VALUE,
    cuidType: responseData?.masterCarrier?.carrierInfo?.carrierCodes.find(
      (item: any) => {
        return !codeTypes.includes(item.codeType)
      }
    )?.codeType,
    activeVehicles:
      responseData?.masterCarrier?.carrierInfo?.numberOfTrucks || t.DASH_VALUE,
  }
}

const getAssetTableData = (data: any) => {
  const tableData = data?.map((item: any) => {
    return {
      assetId: item?.assetId,
      assetEldId: item?.assetEldId ?? "",
      vin: item?.identificationNo ?? "",
      miles: item?.speedIndexDetails?.totalMilesRecorded != null ? item.speedIndexDetails.totalMilesRecorded.toFixed(2) : t.DASH_VALUE,
      score: item?.score != null ? item.score.toFixed(2) : t.DASH_VALUE,
      harshIndex: item?.harshEventsIndex != null ? item.harshEventsIndex.toFixed(2) : t.DASH_VALUE,
      speedIndex: item?.speedIndex != null ? item.speedIndex.toFixed(2) : t.DASH_VALUE,
      geoIndex: item?.geographicalIndex != null ? item.geographicalIndex.toFixed(2) : t.DASH_VALUE,
      // updated: item?.updated ?? "",
    };
  });
  return tableData;
};

const getIndexDiff = (riskData: any, totalDiff: number) => {
  if (riskData?.length <= 1 || isNaN(totalDiff)) {
    return {
      diff: '0',
      color: colors.silver40,
      icon: 'icon_up',
    }
  } else {
    return {
      diff: Math.trunc(Math.abs(totalDiff))?.toString(),
      color:
        totalDiff > 0
          ? colors.green40
          : totalDiff < 0
          ? colors.red40
          : colors.silver40,
      icon: totalDiff >= 0 ? 'icon_up' : 'icon_down',
    }
  }
}

export { getInvitedCarrierData, getCarrierTableData, getSecondaryCarrierTableData, getAssetTableData, getIndexDiff, getMasterCarrierData }
